import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { DialogTypes } from 'common/enums/components/dialog-types.enum';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { COMMUNITY_PUBLIC_FIELDS } from 'common/graphql/queries/community/community-public-fields';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { openDialog, openSnackbar } from 'store/actions';
var JoinCommunityByLink = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    var joinLinkString = _a.joinLinkString, communityId = _a.communityId;
    var t = useTranslation().t;
    var _3 = useQuery(COMMUNITY_PUBLIC_FIELDS, {
        variables: {
            id: communityId
        }
    }), data = _3.data, loading = _3.loading, error = _3.error;
    var canJoinViaCode = (((_c = (_b = data === null || data === void 0 ? void 0 : data.community) === null || _b === void 0 ? void 0 : _b.privacy) === null || _c === void 0 ? void 0 : _c.isPrivate) && ((_e = (_d = data === null || data === void 0 ? void 0 : data.community) === null || _d === void 0 ? void 0 : _d.participationSettings) === null || _e === void 0 ? void 0 : _e.joinViaCode)) ||
        (!((_g = (_f = data === null || data === void 0 ? void 0 : data.community) === null || _f === void 0 ? void 0 : _f.privacy) === null || _g === void 0 ? void 0 : _g.isPrivate) &&
            !((_j = (_h = data === null || data === void 0 ? void 0 : data.community) === null || _h === void 0 ? void 0 : _h.participationSettings) === null || _j === void 0 ? void 0 : _j.allUsersCanJoin) &&
            ((_l = (_k = data === null || data === void 0 ? void 0 : data.community) === null || _k === void 0 ? void 0 : _k.participationSettings) === null || _l === void 0 ? void 0 : _l.joinViaCode));
    var canJoinPublic = !((_o = (_m = data === null || data === void 0 ? void 0 : data.community) === null || _m === void 0 ? void 0 : _m.privacy) === null || _o === void 0 ? void 0 : _o.isPrivate) && ((_q = (_p = data === null || data === void 0 ? void 0 : data.community) === null || _p === void 0 ? void 0 : _p.participationSettings) === null || _q === void 0 ? void 0 : _q.allUsersCanJoin);
    var canJoinViaLink = joinLinkString &&
        ((!((_s = (_r = data === null || data === void 0 ? void 0 : data.community) === null || _r === void 0 ? void 0 : _r.privacy) === null || _s === void 0 ? void 0 : _s.isPrivate) &&
            !((_u = (_t = data === null || data === void 0 ? void 0 : data.community) === null || _t === void 0 ? void 0 : _t.participationSettings) === null || _u === void 0 ? void 0 : _u.allUsersCanJoin) &&
            ((_w = (_v = data === null || data === void 0 ? void 0 : data.community) === null || _v === void 0 ? void 0 : _v.participationSettings) === null || _w === void 0 ? void 0 : _w.joinViaLink)) ||
            (((_y = (_x = data === null || data === void 0 ? void 0 : data.community) === null || _x === void 0 ? void 0 : _x.privacy) === null || _y === void 0 ? void 0 : _y.isPrivate) && ((_0 = (_z = data === null || data === void 0 ? void 0 : data.community) === null || _z === void 0 ? void 0 : _z.participationSettings) === null || _0 === void 0 ? void 0 : _0.joinViaLink)));
    var canJoinCommunity = canJoinViaLink || canJoinViaCode || canJoinPublic;
    var dispatch = useDispatch();
    useEffect(function () {
        if (error) {
            dispatch(openSnackbar({
                message: t('Сообщество не найдено'),
                severity: SnackbarSeverity.ERROR
            }));
        }
    }, [error]);
    var communityJoinDialog = function () {
        var _a;
        dispatch(openDialog({
            dialogType: DialogTypes.JoinCommunityRequestDialog,
            dialogProps: {
                joinVia: canJoinViaCode && !joinLinkString ? 'privateCode' : 'public',
                communityId: communityId,
                joinLinkString: canJoinViaLink ? joinLinkString : undefined,
                communityName: (_a = data === null || data === void 0 ? void 0 : data.community) === null || _a === void 0 ? void 0 : _a.name
            }
        }));
    };
    useEffect(function () {
        var _a, _b, _c, _d;
        if (data && ((_a = data === null || data === void 0 ? void 0 : data.community) === null || _a === void 0 ? void 0 : _a.areYouParticipant)) {
            dispatch(openSnackbar({
                message: t('COMMUNITY_USER_ALREADY_EXISTS'),
                severity: SnackbarSeverity.INFO
            }));
        }
        if (data && !((_b = data === null || data === void 0 ? void 0 : data.community) === null || _b === void 0 ? void 0 : _b.areYouParticipant) && canJoinCommunity) {
            communityJoinDialog();
        }
        if (data &&
            !((_c = data === null || data === void 0 ? void 0 : data.community) === null || _c === void 0 ? void 0 : _c.areYouParticipant) &&
            (canJoinCommunity === false || !((_d = data === null || data === void 0 ? void 0 : data.community) === null || _d === void 0 ? void 0 : _d.isExplicitlyCreated))) {
            dispatch(openSnackbar({
                message: t('Вы не можете присоединиться к этому сообществу'),
                severity: SnackbarSeverity.ERROR
            }));
        }
    }, [data]);
    if (loading)
        return _jsx(CircularProgressMui, {}, void 0);
    return data && ((_1 = data === null || data === void 0 ? void 0 : data.community) === null || _1 === void 0 ? void 0 : _1.isExplicitlyCreated) ? (_jsx(Redirect, { to: "/community/".concat((_2 = data === null || data === void 0 ? void 0 : data.community) === null || _2 === void 0 ? void 0 : _2.url) }, void 0)) : (_jsx(Redirect, { to: "/communities" }, void 0));
};
export default JoinCommunityByLink;
